export default "/assets/website/images/20142.jpeg?779ed79637795c8f6addb848b03925ad";